import ReactDOMServer from 'react-dom/server';
import {
  AppCard,
  AppInputNumber,
  AppSingleSelect,
} from '@/layout/AppComponents';
import Translator from '../../../components/helpers/Translator';
import _ from 'lodash';

export default function ModuleComsaEnvironmentalMaritime(props) {
  const {
    values,
    errors,
    setFieldValue,
    noYesOptions,
  } = props;

  return (
    <AppCard
      header={ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="maritime"
        />
      )}
      className="mb-2"
    >
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.carry.out.dredging.seabed.yes.indicate.estimated.volume"
          />
        )}
        value={values?.dredgingMarineBottom}
        error={errors?.dredgingMarineBottom}
        onChange={(opt) => setFieldValue('dredgingMarineBottom', opt)}
        isClearable
      />
      {_.isNumber(values?.dredgingMarineBottom) && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('dredgingMarineBottomQuantity', value)
            }
            value={values?.dredgingMarineBottomQuantity}
            error={errors?.dredgingMarineBottomQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.carry.out.underwater.blasting"
          />
        )}
        value={values?.marineDemolitionNeed}
        error={errors?.marineDemolitionNeed}
        onChange={(opt) => setFieldValue('marineDemolitionNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="works.expected.storage.handling.products.susceptible.explosion"
          />
        )}
        value={values?.demolitionProductCollection}
        error={errors?.demolitionProductCollection}
        onChange={(opt) => setFieldValue('demolitionProductCollection', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.fillings.maritime.terrestrial.areas.yes.indicate.volume"
          />
        )}
        value={values?.marineBottomBuryingNeed}
        error={errors?.marineBottomBuryingNeed}
        onChange={(opt) => setFieldValue('marineBottomBuryingNeed', opt)}
        isClearable
      />
      {values?.marineBottomBuryingNeed === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('marineBottomBuryingNeedQuantity', value)
            }
            value={values?.marineBottomBuryingNeedQuantity}
            error={errors?.marineBottomBuryingNeedQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.carry.out.fillings.with.prefabricated.caissons"
          />
        )}
        value={values?.prefabricatedDrawerNeed}
        error={errors?.prefabricatedDrawerNeed}
        onChange={(opt) => setFieldValue('prefabricatedDrawerNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="situ.execution.caissons.foreseen.affirmative.indicate.estimated.concreting.volume"
          />
        )}
        value={values?.drawerExecution}
        error={errors?.drawerExecution}
        onChange={(opt) => setFieldValue('drawerExecution', opt)}
        isClearable
      />
      {values?.drawerExecution === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('drawerExecutionQuantity', value)
            }
            value={values?.drawerExecutionQuantity}
            error={errors?.drawerExecutionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="piloting.sheeting.execution.foreseen.seabed.yes.estimated.volume"
          />
        )}
        value={values?.marineBottomScreenExecution}
        error={errors?.marineBottomScreenExecution}
        onChange={(opt) => setFieldValue('marineBottomScreenExecution', opt)}
        isClearable
      />
      {values?.marineBottomScreenExecution === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('marineBottomScreenExecutionQuantity', value)
            }
            value={values?.marineBottomScreenExecutionQuantity}
            error={errors?.marineBottomScreenExecutionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="construction.breakwaters.causeways.foreseen"
          />
        )}
        value={values?.riprapBuilding}
        error={errors?.riprapBuilding}
        onChange={(opt) => setFieldValue('riprapBuilding', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="execution.prefabricated.pile.driving.foreseen.seabed"
          />
        )}
        value={values?.marineBottomPrefabricatedPiling}
        error={errors?.marineBottomPrefabricatedPiling}
        onChange={(opt) =>
          setFieldValue('marineBottomPrefabricatedPiling', opt)
        }
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.project.carry.out.sheet.piling.seabed"
          />
        )}
        value={values?.marineBottomTablestacadosNeed}
        error={errors?.marineBottomTablestacadosNeed}
        onChange={(opt) => setFieldValue('marineBottomTablestacadosNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.use.ships.dredgers.barges"
          />
        )}
        value={values?.shipUseNeed}
        error={errors?.shipUseNeed}
        onChange={(opt) => setFieldValue('shipUseNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.stockpile.maritime.terrestrial.yes.estimated.volume"
          />
        )}
        value={values?.aridCollection}
        error={errors?.aridCollection}
        onChange={(opt) => setFieldValue('aridCollection', opt)}
        isClearable
      />
      {values?.aridCollection === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) => setFieldValue('aridCollectionQuantity', value)}
            value={values?.aridCollectionQuantity}
            error={errors?.aridCollectionQuantity}
            isClearable
          />
        </div>
      )}
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.volume.earthworks.maritime.excavations.embankments.etc"
          />
        )}
        onChange={(value) => setFieldValue('soilMovementQuantity', value)}
        value={values?.soilMovementQuantity}
        error={errors?.soilMovementQuantity}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="possibility.impact.historical.artistic.heritage.archaeological.sites.project"
          />
        )}
        value={values?.archaeologicalAffection}
        error={errors?.archaeologicalAffection}
        onChange={(opt) => setFieldValue('archaeologicalAffection', opt)}
        isClearable
      />
    </AppCard>
  );
}
